export default __webpack_public_path__ + "static/media/logo-dark.ff0e8b81.svg";